import { RiCloseLine, RiSubtractLine } from 'react-icons/ri';
import appIcon from '../assets/icon.png';

const HeaderBar = ({ connected, onMinimize, onClose, title = 'Desktop SFTP Console' }) =>
<header className="sticky top-0 z-30 flex items-center justify-between border-b border-border bg-panel px-4 py-2 window-drag select-none">
    <div className="flex items-center gap-3">
      <img src={appIcon} alt="logo" className="h-8 w-8 rounded-lg object-cover" />
      <div>
        <p className="text-xs font-semibold text-textMuted">Kinetic SFTP</p>
        <h1 className="text-base font-semibold text-white m-0">{title}</h1>
      </div>
    </div>
    <div className="flex items-center gap-3 window-no-drag">
      <span
      className={`rounded-full px-3 py-1 text-xs ${
      connected ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-200'}`
      }>
      
        {connected ? 'Connected' : 'Disconnected'}
      </span>
      {onMinimize ?
      <button
        type="button"
        onClick={onMinimize}
        className="flex h-8 w-8 items-center justify-center rounded-md bg-inset/80 text-textMuted hover:text-white"
        title="Minimize">
        
          <RiSubtractLine />
        </button> :
      null}
      {onClose ?
      <button
        type="button"
        onClick={onClose}
        className="flex h-8 w-8 items-center justify-center rounded-md bg-red-500/80 text-white hover:bg-red-500"
        title="Close">
        
          <RiCloseLine />
        </button> :
      null}
    </div>
  </header>;


export default HeaderBar;
